var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-chip',{attrs:{"text-color":"white","small":"","color":this.userColor}},[_vm._v(" "+_vm._s(_vm.userStatus)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }